import { render, staticRenderFns } from "./activityThemePage.vue?vue&type=template&id=6fe3ad36&scoped=true"
import script from "./activityThemePage.vue?vue&type=script&lang=js"
export * from "./activityThemePage.vue?vue&type=script&lang=js"
import style0 from "./activityThemePage.vue?vue&type=style&index=0&id=6fe3ad36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe3ad36",
  null
  
)

export default component.exports